import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import TextFieldTheme from "../../../../shared/general/TextFieldTheme";
import ButtonBlue from "../../../../shared/general/ButtonBlue";

import { postGroupGpsLocations, getAllLocations } from "../../../../../../actions/gpsLocations";
import { Typography } from "@mui/material";

const StyleWrapForm = styled("div")({
  paddingTop: 16,
});

const DialogGroupGpsLocations = (props) => {
  const { open, handleClose, handleOpenAlert, handleChangeAlertType } = props;
  const dispatch = useDispatch();
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const [formData, setFormData] = useState({
    name: "",
    idCompany: "",
    createBy: "",
    createDate: dayjs(new Date()).format("YYYY-MM-DD"),
    isActive: true,
  });

  const handleSaveGroupGpsLocations = async () => {
    if (userProfile) {
      formData.idCompany = userProfile.idCompany;
      formData.createBy = userProfile.idEmp;
      const result = await dispatch(postGroupGpsLocations(formData));
      if (result) {
        handleOpenAlert();
        if (result.status === 200) {
          handleChangeAlertType("success");
          if (userProfile) {
            dispatch(getAllLocations(userProfile.idCompany));
          }
        } else {
          handleChangeAlertType("error");
        }
        handleClose();
      } else {
        handleOpenAlert();
        handleChangeAlertType("error");
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"เพิ่มกลุ่มพื้นที่/ตำแหน่ง"}
      </DialogTitle>
      <DialogContent>
        <StyleWrapForm>
          <TextFieldTheme
            name="name"
            onChange={handleChange}
            label="ชื่อกลุ่มพื้นที่/ตำแหน่ง"
          />
        </StyleWrapForm>
      </DialogContent>
      <DialogActions>
        <ButtonBlue onClick={handleClose}>ยกเลิก</ButtonBlue>
        <ButtonBlue
          onClick={handleSaveGroupGpsLocations}
          variant={"contained"}
          autoFocus
        >
          บันทึกข้อมูล
        </ButtonBlue>
      </DialogActions>
    </Dialog>
  );
};

export default DialogGroupGpsLocations;
